import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=6dd10483&scoped=true"
import script from "./Results.js?vue&type=script&lang=js&external"
export * from "./Results.js?vue&type=script&lang=js&external"
import style0 from "./Results.scss?vue&type=style&index=0&id=6dd10483&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd10483",
  null
  
)

export default component.exports